<div class="signin-page">
  <div class="signin-card">

    <div class="signin-card__header">
      <div class="brand">
        <img src="assets/img/cereus-logo.svg" alt="Cereus Software" class="auth-logo">
      </div>
    </div>

    <div class="signin-card__body">
      <h1 class="signin-title">Sign in</h1>
      <p class="signin-subtitle">Use your Cereus account to continue.</p>

      <form *ngIf="pinStep" (ngSubmit)="onVerifyPin()" novalidate>
        <p class="signin-subtitle">
          Enter the 6-digit PIN we sent to {{ pinEmail || 'your e-mail' }}.
        </p>
        <div class="form-field">
          <label for="pin">Verification PIN</label>
          <input id="pin" name="pin" type="text" inputmode="numeric" autocomplete="one-time-code"
            maxlength="6" [(ngModel)]="pin" />
        </div>
        <p class="form-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
        <button type="submit" class="btn btn--primary" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Verifying…' : 'Verify' }}
        </button>
        <div class="signin-links">
          <button type="button" class="link-btn" (click)="cancelPin()">Back to sign in</button>
        </div>
      </form>

      <ng-container *ngIf="!pinStep">
      <form (ngSubmit)="onSignIn()" novalidate>
        <div class="form-field">
          <label for="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            autocomplete="username"
            [(ngModel)]="email"
          />
        </div>

        <div class="form-field">
          <label for="password">Password</label>
          <div class="password-input">
            <input
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              [(ngModel)]="password"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <svg *ngIf="!showPassword" viewBox="0 0 24 24" width="18" height="18">
                <path d="M12 5c-5 0-9 4.5-10 7 1 2.5 5 7 10 7s9-4.5 10-7c-1-2.5-5-7-10-7z" fill="none" stroke="currentColor" stroke-width="1.6"/>
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.6"/>
              </svg>
              <svg *ngIf="showPassword" viewBox="0 0 24 24" width="18" height="18">
                <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.6"/>
                <path d="M12 5c-5 0-9 4.5-10 7 1 2.5 5 7 10 7s9-4.5 10-7c-1-2.5-5-7-10-7z" fill="none" stroke="currentColor" stroke-width="1.6"/>
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.6"/>
              </svg>
            </button>
          </div>
        </div>

        <p class="form-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button type="submit" class="btn btn--primary" [disabled]="isSubmitting || isRedirectingToSso || isCheckingSession">
          {{ isCheckingSession ? 'Checking session…' : (isSubmitting ? 'Signing in…' : 'Sign in') }}
        </button>
      </form>

      <div class="signin-links">
        <button type="button" class="link-btn" (click)="onForgotPassword()">Forgot Password ?</button>
        <span class="dot">·</span>
        <button type="button" class="link-btn" (click)="onCreateAccount()">Create Account</button>
      </div>

      <ng-container *ngIf="ssoEnabled">
      <div class="divider">
        <span>OR</span>
      </div>

      <button type="button" class="btn btn--microsoft" (click)="onMicrosoftSignIn()"
        [disabled]="isSubmitting || isRedirectingToSso || isCheckingSession">
        <svg viewBox="0 0 21 21" width="18" height="18" aria-hidden="true">
          <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
          <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
          <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
        </svg>
        <span>{{ isRedirectingToSso ? 'Redirecting to Microsoft…' : 'Sign in with Microsoft' }}</span>
      </button>
      </ng-container>
      </ng-container>

      <p class="prototype-note">
        <strong>Copyright © Cereus Software 2025 All Rights Reserved.</strong><br />
         Cereus Software, 902 Clint Moore Rd. Suite 226, <br />Boca Raton FL 33487.
      </p>
    </div>
  </div>
</div>